import React from "react";
import { Header, Segment } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import messages from "../messages";
import styles from "./../styles.module.scss";
import currency from "currency.js";
import { Slice } from "../../../types";
import { displaySliceId } from "../../../utils/sliceFormat";

interface Props {
  title: string;
  value?: string;
  change?: string;
  changePercentage?: string;
  high: string;
  low: string;
  sliceDetails: any;
}

const Instrument = ({
  title,
  value,
  change,
  changePercentage,
  high,
  low,
  sliceDetails,
}: Props) => {
  return (
    <Segment raised>
      <Header as="h3">{title}</Header>
      <div className={styles.instrument}>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.date} />
        </button>
        <span id="instrument-date">
          {sliceDetails.date ? sliceDetails.date : "-"}
        </span>
        <p></p>
      </div>
      <div className={styles.instrument}>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.slice} />
        </button>
        <span id="instrument-slice">
          {sliceDetails.id ? displaySliceId(sliceDetails.id) : "-"}
        </span>
        <p></p>
      </div>
      <div className={styles.instrument}>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.value} />
        </button>
        <span id="instrument-value">{value}</span>
        <p></p>
      </div>
      <div className={styles.instrument}>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.change} />
        </button>
        <span id="instrument-change">{change}</span>
        <p></p>
      </div>
      <div className={styles.instrument}>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.high} />
        </button>
        <span id="instrument-range-high">{high}</span>
        <p></p>
      </div>
      <div className={styles.instrument}>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.low} />
        </button>
        <span id="instrument-range-low">{low}</span>
        <p></p>
      </div>
    </Segment>
  );
};

export default Instrument;
